import React from 'react';
import { Modal, Input, Form, Select, InputNumber, Col } from 'antd';


const { Option } = Select;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {

                    nombre: values.nombre,
                    codigoBarra: values.codigoBarra,
                    codigoReferencia: values.codigoReferencia,
                    precioUnitario: values.idMoneda.key == 1 ? parseFloat(values.precioUnitarioSoles) : parseFloat(values.precioUnitarioDolares),
                    nombreMarca: this.props.formValues.nombreMarca,
                    idMoneda: values.idMoneda.key

                }
                this.props.onSave(form, this.props.form);
            }
        });
    }


    render() {
        const { getFieldDecorator } = this.props.form;

        getFieldDecorator('flagMoneda', { initialValue: this.props.formValues.idMoneda == 1 ? true : false });

        return (
            <Modal
                title={"Impresión"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Imprimir"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>
                    <div className="row">

                        <div className="col-md-12 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('idMoneda', {
                                    initialValue: this.props.formValues.idMoneda ?
                                        { key: this.props.formValues.idMoneda } : undefined,
                                })(
                                    <Select
                                        showSearch
                                        labelInValue
                                        placeholder={"Seleccione Moneda"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ flagMoneda: option.key == 1 ? true : false });
                                        }}
                                    >
                                        {this.props.formValues.monedas.map(item => (

                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                        maxLength={45}

                                    />
                                )}
                            </Form.Item>
                        </div>


                        <div className="col-md-6 form-group">
                            <Form.Item label="Codigo Barra">
                                {getFieldDecorator('codigoBarra', {
                                    initialValue: this.props.formValues.codigoBarra
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                        disabled
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Codigo Referencia">
                                {getFieldDecorator('codigoReferencia', {
                                    initialValue: this.props.formValues.codigoReferencia
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                        disabled
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Precio Unitario Dolares">
                                {getFieldDecorator('precioUnitarioDolares', {
                                    initialValue: this.props.formValues.precioUnitarioDolares
                                })(
                                    <InputNumber
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                        style={{ width: '100%' }}
                                        precision={2}
                                        disabled={this.props.form.getFieldValue("flagMoneda")}

                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-6 form-group">
                            <Form.Item label="Precio Unitario Soles">
                                {getFieldDecorator('precioUnitarioSoles', {
                                    initialValue: this.props.formValues.precioUnitarioSoles,
                                })(
                                    <InputNumber
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                        style={{ width: '100%' }}
                                        precision={2}
                                        disabled={!this.props.form.getFieldValue("flagMoneda")}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>


                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)